/**
 * Models Slider
 * @requires https://swiperjs.com/
 */

export default (() => {
  /* eslint-disable no-undef, no-unused-vars  */
  const contentSlider = new Swiper('#models-slider', {
    effect: 'fade',
    allowTouchMove: false,
  })

  // Get navigation elements
  const navContainer = document.getElementById('models-slider-nav')
  const navItems = navContainer.querySelectorAll('.models-slider-nav-item')

  // All galleries
  const galleries = document.querySelectorAll('.gallery')

  // Add click handlers to navigation items
  navItems.forEach((item, index) => {
    item.addEventListener('click', () => {
      if (!item.classList.contains('active')) {
        navItems.forEach((nav) => {
          nav.classList.remove('active')
          setTimeout(() => {
            nav.classList.remove('animated')
          }, 150)
        })

        item.classList.add('active')
        setTimeout(() => {
          item.classList.add('animated')
        }, 150)

        contentSlider.slideTo(index)

        const galleryId = item.getAttribute('data-gallery')

        galleries.forEach((g) => {
          if (g.id === galleryId) {
            g.classList.remove('h-0')
          } else {
            g.classList.add('h-0')
          }
        })
      }
    })
  })

  /* eslint-enable no-undef, no-unused-vars  */
})()
